import Image from 'next/image'
import { Hooks } from '@microfrontends/react-components'
import { useEffect, useMemo, useRef, useState } from 'react'
import { EmptyDiv } from '../CompanyDetail/CompanyDetail.css'
import { CompanyVideo, ImageWrapper, VideoWrapper } from './Video.css'
import { useStore } from '../../store'

interface Props {
    t: (text: string) => string
    videoUrls?: string[]
}

const EMPTY_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_URL}/company-assets/images/icon-videos1x.png`
const REGEX = /https:\/\/youtu.be/g
const REPLACE_TEXT = 'https://youtube.com/watch?v='

const Video: React.FC<Props> = ({ t, videoUrls }) => {
    const convertedUrl = useMemo(() => {
        if (videoUrls) {
            let initialUrl = videoUrls.length > 0 ? videoUrls[0] : ''
            if (REGEX.test(initialUrl)) {
                initialUrl = initialUrl.replace(REGEX, REPLACE_TEXT)
            }
            const youtubeUrl = initialUrl.replace('watch?v=', 'embed/')
            const youtubeArr = youtubeUrl ? youtubeUrl.split('&') : ''
            const splitUrl = youtubeArr[0] ?? ''
            return splitUrl
        }
        return ''
    }, [videoUrls])

    const { isRobot } = useStore().state
    const videoRef = useRef<HTMLDivElement>(null)
    const [isVideoLoaded, setVideoLoaded] = useState(isRobot)
    const [isVideoOnScreen] = Hooks.useElementOnScreen({
        target: videoRef,
        options: {
            threshold: 0.5
        }
    })

    useEffect(() => {
        if (isVideoOnScreen) {
            setVideoLoaded(true)
        }
    }, [isVideoOnScreen])

    return (
        <div ref={videoRef}>
            <h2>{t('Video')}</h2>
            {convertedUrl ? (
                <VideoWrapper>
                    {isVideoLoaded && (
                        <CompanyVideo className='company-video' src={convertedUrl} allowFullScreen></CompanyVideo>
                    )}
                </VideoWrapper>
            ) : (
                <EmptyDiv>
                    <ImageWrapper>
                        <Image src={EMPTY_IMAGE} alt={t('There is no video for the moment.')} layout='fill' />
                    </ImageWrapper>
                    <p>{t('There is no video for the moment.')}</p>
                </EmptyDiv>
            )}
        </div>
    )
}

export default Video
